// @flow
import React from 'react'
import {Router, Switch, Route} from 'react-router'
import { createBrowserHistory } from 'history'
import styled from 'styled-components'
import {observer} from 'mobx-react'

import 'react-grid-layout/css/styles.css'
import 'react-resizable/css/styles.css'

import Header from 'components/Header'
import Alert from 'components/Alert'

import ComponentList from 'routes/ComponentList'
import Config from 'routes/Config'
import Grid from 'routes/Grid'
import Storybook from './Storybook'
import storyStore from 'stores/storybook'

const history = createBrowserHistory()

export default observer(class App extends React.Component<{}> {
  
  render(){
    return (
      <Router history={history}>
        <Wrapper className='app'>
          <Header history={history}/>
          <Alert />
          {storyStore.activeId || <Switch>
            <Route exact path='/' component={ComponentList} />
            <Route exact path='/config' component={Config} />
            <Route exact path='/grid/:gridName' component={Grid} />
            {/* <Route exact path='/storybook' component={Storybook} /> */}
            {/* <Route exact path='/storybook/:id' component={Storybook} /> */}
          </Switch>}
          <Storybook />
        </Wrapper>
      </Router>
    )
  }
})

const Wrapper = styled.div`
  height: 100%;
  background: white;
`


// WEBPACK FOOTER //
// ./src/App.js